import { useQuery } from "@apollo/client";
import { View } from "react-native";
import GetGatheringPrivacyInfoDocument from "src/api/graphql/__generated__/documents/GetGatheringPrivacyInfoDocument";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { ModalComponentProps, ModalWrapperWithHeader, useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import { paddingLarge } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import GatheringPrivacyBlurb from "./components/GatheringPrivacyBlurb";
import { useGatheringParticipantPrivacyModalDimensions } from "./GatheringParticipantPrivacySkeleton";

const GatheringParticipantPrivacyModal = ({ variant }: ModalComponentProps) => {
	const {
		props: { gatheringId },
	} = useInsideModal<GatheringModal["GatheringParticipantPrivacy"]>();

	const { data } = useQuery(GetGatheringPrivacyInfoDocument, {
		fetchPolicy: "cache-and-network",
		variables: {
			input: {
				gatheringId,
			},
		},
	});
	const style = useGatheringParticipantPrivacyModalDimensions();
	const privacy = data?.getGathering?.privacy ?? [];

	return (
		<View style={style}>
			<ModalWrapperWithHeader variant={variant} title="About">
				<View
					style={{
						marginTop: paddingLarge,
						maxWidth: 500,
						width: "100%",
						alignSelf: "center",
						paddingHorizontal: paddingLarge,
					}}
				>
					{privacy.includes(GatheringPrivacy.FullPublic) ? (
						<GatheringPrivacyBlurb
							title="Public album"
							description="Albums can only be accessed via the link shared with you. Anyone can view the contents of this album without joining"
						/>
					) : (
						<GatheringPrivacyBlurb
							title="Private album"
							description="Albums can only be accessed via the link shared with you"
						/>
					)}
					{privacy.includes(GatheringPrivacy.PasswordRequired) &&
						data?.getGathering?.password && (
							<View
								style={{
									marginVertical: paddingLarge,
								}}
							>
								<Text color="TextLight">Password</Text>
								<Text large bold testID="Privacy-PasswordValue">
									{data.getGathering.password}
								</Text>
							</View>
						)}
					{privacy.includes(GatheringPrivacy.HideDuplicatePhotos) && (
						<GatheringPrivacyBlurb
							title="Deduplicate content"
							description="Duplicate photos and videos are automatically hidden"
						/>
					)}
					{privacy.includes(GatheringPrivacy.UploadApproval) && (
						<GatheringPrivacyBlurb
							title="Upload approval"
							description="Content requires approval from a host before being visible"
						/>
					)}
				</View>
			</ModalWrapperWithHeader>
		</View>
	);
};
export default GatheringParticipantPrivacyModal;
